
import ActionColumnRenderer from '../../../app/Table/renderer/ActionColumnRenderer'

export default class MrdDocumentFormColumnRenderer extends ActionColumnRenderer<any> {
  getColumns() {
    return [
      { name: 'Claim Number', selector: 'claimNumber' },
      { name: 'Investigator Name', selector: 'investigatorName' },
      { name: "Emp Id", selector: "investigatorEmpId"},
      { name: 'Company Name', selector: 'insuranceCompany' },
      { name: "Hospital", selector: "hospitalName"},
      {
        name: "Hospital Location",
        selector: "hospitalDistrict",
        cell: (row: any) => `${row.hospitalDistrict ?? ''} / ${row.hospitalState ?? ''}`
      },
      { name: "Allocator", selector: "claimAnalyst"},
      {
        name: 'Actions',
        selector: 'id',
        cell: this.renderActionColumn,
      },

      
      
    ]
  }
}
